import {ListColumnType, ListHeader} from "../../common/list/List.props";
import {getInquiryTypeName} from "./SearchType";

export const HEADERS: ListHeader[] = [
    {
        type: ListColumnType.CHECK_BOX,
        name: "",
        key: ""
    },
    {
        type: ListColumnType.STATUS,
        name: "상태",
        key: "isCompleted",
        convertToString: (isCompleted: boolean): string => {
            return isCompleted ? "처리 완료" : "미처리";
        },
        getCellStyle: (isCompleted: boolean): {} => {
            return {
                color: isCompleted? "" : "var(--red600)"
            };
        }
    },
    {
        type: ListColumnType.NORMAL,
        name: "분류",
        key: "type",
        convertToString: (type: number): string => {
            return getInquiryTypeName(type) || "";
        }
    },
    {
        type: ListColumnType.NORMAL,
        name: "사용자명",
        key: "name"
    },
    {
        type: ListColumnType.NORMAL,
        name: "이메일",
        key: "email"
    },
    {
        type: ListColumnType.NORMAL,
        name: "연락처",
        key: "phone"
    },
    {
        type: ListColumnType.ELLIPSIS,
        name: "문의 내용",
        key: "content"
    },
    {
        type: ListColumnType.NORMAL,
        name: "문의 일시",
        key: "createdAt",
        convertToString: (datetime: string): string => {
            return datetime.replace("T", " ");
        }
    }
];